import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McDropdownLegacy, McInputNew, McTextAreaNew } from "../../../../../../components";
import { TEST_AV_ALARMSYSTEMER_METODER, TestAvAlarmsystemerEnum } from "../../../../../../mc-shared/gkReportConstants";
import { IGKRapport, IGKTestAvAlarmsystemerResultater } from "../../../../../../mc-shared/reportSchemas/gkReportSchema";
import { Radio, Paper, Stack, Title } from "@mantine/core";
const TestAvAlarmsystemer: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKTestAvAlarmsystemerResultater;
}> = ({ data, onUpdateEditData }) => {
  const addOrRemoveTest = (test: TestAvAlarmsystemerEnum) => {
    data.inndata.valgtMetode[test] = !data.inndata.valgtMetode[test];
    onUpdateEditData("testResultater.testAvAlarmsystemer.inndata.valgtMetode", data.inndata.valgtMetode);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Test av alarmsystemer</Title>
        <b>Velg hvilke tester som skal utføres?</b>
        <div className="w-25 mb-4">
          <McDropdownLegacy
            filterOptions={TEST_AV_ALARMSYSTEMER_METODER.map((test) => {
              return {
                ...test,
                isActive: data.inndata.valgtMetode[test.value],
              };
            })}
            onClick={(value) => addOrRemoveTest(value)}
            title="Velg tester"
            color="secondary"
            textColor="text-black"
          />
        </div>
        {data.inndata.valgtMetode[TestAvAlarmsystemerEnum.LUKEAAPNING] === true && (
          <>
            <h4>Lukeåpning</h4>
            <div>
              <div className="d-flex flex-column">
                                <Radio
                  checked={data.inndata.lukeaapningResultater.godkjent === true}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.testAvAlarmsystemer.inndata.lukeaapningResultater.godkjent",
                  true,
                  )
                  }
                  label="Godkjent"
                />
                                <Radio
                  checked={data.inndata.lukeaapningResultater.godkjent === false}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.testAvAlarmsystemer.inndata.lukeaapningResultater.godkjent",
                  false,
                  )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2 mb-4">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.lukeaapningResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.testAvAlarmsystemer.inndata.lukeaapningResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[TestAvAlarmsystemerEnum.LUFTHASTIGHETSINDIKATOR] === true && (
          <>
            <h4>Lufthastighetsindikator</h4>
            <div>
              <div className="d-flex flex-column">
                                <Radio
                  checked={data.inndata.lufthastighetsIndikatorResultater.godkjent === true}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.testAvAlarmsystemer.inndata.lufthastighetsIndikatorResultater.godkjent",
                  true,
                  )
                  }
                  label="Godkjent"
                />
                                <Radio
                  checked={data.inndata.lufthastighetsIndikatorResultater.godkjent === false}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.testAvAlarmsystemer.inndata.lufthastighetsIndikatorResultater.godkjent",
                  false,
                  )
                  }
                  label="Ikke godkjent"
                />
              </div>
            </div>
            <div className="w-50 mt-2">
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.lufthastighetsIndikatorResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.testAvAlarmsystemer.inndata.lufthastighetsIndikatorResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
      </Stack>
    </Paper>
  );
};
export default TestAvAlarmsystemer;